<template lang="pug">
table.table(:class='tableClass')
  thead
    tr(style="text-align: left; font: Bold 15px/17px Helvetica; letter-spacing: 0px; color: #343A40; opacity: 1;")
      th(v-for='c in columns', :key='c.title') 
        span.display-block.font-bold(v-html="c.title" :class="[centerColumns.length > 0 &&  !centerColumns.includes(c.key) ? 'text-center': '']")
  tbody
    tr(v-if='this.inlineFilter === true', style="background: #EAEAEA 0% 0% no-repeat padding-box; opacity: 1;")
      td(style="text-align: center;")
      td
      td
        input#name(@change="onnameChange($event)" placeholder="Tìm theo tên" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 5px 10px;")
      td
        select#grades_id(@change="onGradesChange($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;")
          option( value='0') Tất cả
          option(v-for='o in filterGrades' :value='o.id') {{o.name}}
      td(style="text-align: center;")
      td(style="text-align: center;")
      td
      td
      td(width="70px")
    tr(v-if='this.data.length === 0') 
      td(style='text-align: center;' colspan="8")
        | Không có dữ liệu
    tr(v-else v-for='(item, index) in data' v-bind:id="'row' + item.id")
      td(v-for='c in columns' :class="[centerColumns.length > 0 &&  !centerColumns.includes(c.key) ? 'text-center': '']")
        a.link(v-if='c.type === "channel_count"', v-html='itemValue(item, c)', v-on:click="onChannel(item)")
        a.link(v-else-if='c.type === "user_count"', v-html='itemValue(item, c)', v-on:click="onMember(item)")
        span.list-action(v-else-if='c.key==="stt"' v-html='(index  + 1)')
        span.list-action(v-else-if='c.type==="select_approval" && !item.private')
          select(@change="onApprovalChange(item, $event)")
            option( value='1' :selected="item.type_approval === 1") Thủ công
            option( value='0' :selected="item.type_approval === 0") Tự động
        span.list-action.function-action(v-else-if='isAction(c)')
          small(@click="editItem(item)")
            img(:src="require('../../assets/images/faces/ic_edit.svg')")
          small(@click="deleteItem(item)")
            img(:src="require('../../assets/images/theory/delete-24px.svg')")
          ShareNetwork.share(network="facebook" :url="url(item)" :title="item.name" :description="item.description")
           img(:src="require('../../assets/images/theory/share-alt.svg')")
          //- small(@click="shareItem(item)")
            img(:src="require('../../assets/images/theory/share-alt.svg')")
          small(v-if="item.private > 0 ")
            img(:src="require('../../assets/images/theory/lock.svg')")
        span.list-action(v-html='itemValue(item, c)' v-else)
</template>

<script>
import moment from 'moment'

export default {
  props: {
    columns: Array,
    data: Array,
    actions: Array,
    centerColumns: Array,
    type: {
      type: String, // default | striped | hover
      default: ''
    },
    inlineFilter: {
      type: Boolean,
      default: false
    },
    filterGrades: Array
  },
  computed: {
    tableClass() {
      return `table-${this.type}`
    }
  },
  mounted () {
  },
  methods: {
    editItem(item) {
      this.$emit('onItemEdit', item)
    },
    shareItem(item) {
      this.$emit('onItemShare', item)
    },
    url(item) {
      let url = window.location.origin + '/' + this.$router.resolve({name: 'join_classes'}).href + 'join-classes/'
      let seoUrl = url + this.$mycontroller.doSanitizeTitle(item.private_community.name) + '/' + this.$mycontroller.doSanitizeTitle(item.name) + '-' + item.id + '/yeucauthamgia'
      return seoUrl
    },
    // privateItem(item) {
    //   this.$emit('onItemPrivate', item)
    // },
    deleteItem(item) {
      this.$emit('onItemDelete', item)
    },
    onApprovalChange(item, event) {
      this.$emit('onApproval', item, event)
    },
    onChannel(item) {
      this.$emit('onChannel', item)
    },
    onMember(item) {
      this.$emit('onMember', item)
    },
    hasValue(item, col) {
      if (col.type === 'action' || item[col.key] === 'undefined' || col.type === 'custom') {
        return false
      } else {
        return true
      }
    },
    fmDate(item, col) {
      return moment(item[col.key]).format('DD/MM/YYYY - hh:mm')
    },
    isAction(col) {
      if (col.type === 'action') return true
      else return false
    },
    itemValue(item, column) {
      var value = item[column.key]
      if (column.type) {
        if (column.type === 'image') {
          if (value === '' || value === null) {
            return '<img src="' + require('../../assets/images/faces/ic_AvatarDefault@2x.png') + '" class="img"/>'
          }
          return '<img src="' + value + '" class="img"/>'
        } else if (column.type === 'date') {
          return this.fmDate(item, column)
        } else if (column.type === 'custom') {
          return value
        } else if (column.type === 'channel_count') {
          return value.aggregate.count
        } else if (column.type === 'user_count') {
          //  return value.pc_users_aggregate.aggregate.count
          return value
        }
      } else {
        if (typeof value === 'object') return value.name
        return value
      }
    },
    onnameChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbyname', event.target.value)
    },
    onGradesChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbygrade', event.target.value)
    }
  }
}

</script>
<style lang="scss">
.text-center{text-align: center;}
.link{cursor: pointer;text-decoration: underline; color:#554BC1;}
.list-action {cursor: pointer;
  small{width: 16px; height: 16px; margin-right: 10px; display: inline-block;
    img{max-width: 100%; height: 16px;}
  }
  a{width: 16px; height: 16px; margin-right: 10px; display: inline-block;
    img{max-width: 100%; height: 16px;}
  }
  select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;}
}
.display-block{display: block;}
.font-bold{font-weight: bold;}
span.list-action{
  &.function-action{text-align: left;}
  .img{border-radius: 50%;width: 30px; height: 30px;}
}
</style>



// WEBPACK FOOTER //
// clTable.vue?88922e5a